import { render, staticRenderFns } from "./AdicaoDeCredito.vue?vue&type=template&id=3b5d0fa6&"
import script from "./AdicaoDeCredito.vue?vue&type=script&lang=js&"
export * from "./AdicaoDeCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports